
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useAppSumoCode = (setIsLogin: (isLogin: boolean) => void) => {
  const [searchParams] = useSearchParams();
  const appsumoCode = searchParams.get("appsumo_code");

  useEffect(() => {
    if (appsumoCode) {
      setIsLogin(false); // Force signup mode for AppSumo users
    }
  }, [appsumoCode, setIsLogin]);

  const redeemAppSumoCode = async (userId: string) => {
    if (!appsumoCode) return;

    try {
      // Call the redeem_appsumo_code function
      const { data: redeemResult, error: redeemError } = await supabase
        .rpc('redeem_appsumo_code', {
          code_to_redeem: appsumoCode,
          user_id: userId
        });

      if (redeemError) {
        throw redeemError;
      }

      if (redeemResult) {
        toast.success("Successfully activated your pro account!");
        return true;
      } else {
        toast.error("Failed to redeem AppSumo code");
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      return false;
    }
  };

  return {
    appsumoCode,
    redeemAppSumoCode
  };
};
